
import { computed, defineComponent, PropType } from "vue";
import { ProcessUserStatusesEnum } from "@/store/modules/document/state";
import { getProcessUserStatusLabel } from "@/utils/labels";

export default defineComponent({
  name: "ProcessUserStatusLabel",
  props: {
    label: {
      type: String as PropType<ProcessUserStatusesEnum>,
      required: true,
    },
  },
  setup(props) {
    const styleClass = computed(() => {
      if (props.label === ProcessUserStatusesEnum.SUCCESS) {
        return "tag tag--success";
      }
      if (props.label === ProcessUserStatusesEnum.DENIED) {
        return "tag tag--error";
      }
      let label = "status-label ";
      if (props.label === ProcessUserStatusesEnum.ACTIVE) {
        label += "status-label--active";
      } else if (props.label === ProcessUserStatusesEnum.WAIT) {
        label += "status-label--wait";
      } else if (props.label === ProcessUserStatusesEnum.CANCELLED) {
        label += "status-label--cancelled";
      }

      return label;
    });

    const statusLabel = computed(() => {
      return getProcessUserStatusLabel(props.label);
    });

    return {
      statusLabel,
      styleClass,
    };
  },
});
